import type { IDistrictSchoolListItem } from "@/providers/store/api/districts/districts.interface";

export function findDistrictSchoolForBoundary(
  schools: readonly IDistrictSchoolListItem[],
  ids: { schoolId?: string | null; schoolInternalId?: string | null },
): IDistrictSchoolListItem | null {
  const schoolId = ids.schoolId?.trim();
  if (schoolId) {
    const byId = schools.find((school) => school.id === schoolId);
    if (byId) {
      return byId;
    }
  }

  const schoolInternalId = ids.schoolInternalId?.trim();
  if (schoolInternalId) {
    const byInternalId = schools.find((school) => school.internalId === schoolInternalId);
    if (byInternalId) {
      return byInternalId;
    }
  }

  return null;
}

export function formatDistrictSchoolGradesRange(
  grades: IDistrictSchoolListItem["grades"] | null | undefined,
): string | null {
  if (grades?.lowestGradeLabel != null && grades?.highestGradeLabel != null) {
    return `${grades.lowestGradeLabel}-${grades.highestGradeLabel}`;
  }

  return null;
}

export function resolveBoundarySchoolDisplayFields(args: {
  schools: readonly IDistrictSchoolListItem[];
  schoolId?: string | null;
  schoolInternalId?: string | null;
  gradesRange: string | null;
  address: string | null;
}): { gradesRange: string | null; address: string | null } {
  const linked = findDistrictSchoolForBoundary(args.schools, {
    schoolId: args.schoolId,
    schoolInternalId: args.schoolInternalId,
  });

  return {
    gradesRange: args.gradesRange ?? formatDistrictSchoolGradesRange(linked?.grades),
    address: args.address ?? linked?.address ?? null,
  };
}
